// lazy-load.directive.ts
import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';

@Directive({
    selector: '[appLazyLoad]'
})
export class LazyLoadDirective implements OnInit {
    @Input() src: string;

    constructor(private el: ElementRef,
        @Inject(PLATFORM_ID) private platformId: any
    ) { }

    ngOnInit() {
        this.loadImage();
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll() {
        this.loadImage();
    }

    private loadImage() {
        if (isPlatformBrowser(this.platformId)) {
            const rect = this.el.nativeElement.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                this.el.nativeElement.src = this.src;
            }
        }
    }
}
